import React, { useState } from 'react';
import { MIcon } from '../../lib/micon';
import type { Schueler } from '../../types';
import { initialen } from '../schueler/profil/format';
import { useAufmerksamkeit, gruende } from './aufmerksamkeit';
import './klasse.css';

// ── Welle K1: Schülerliste der Klasse — Suche, „Braucht Aufmerksamkeit“, „Alle Kinder“ ──
// Ruhig: nur Abweichungen markiert (Grund als Chip), keine OK-Abzeichen.
// huelle: optionaler Rahmen je Zeile (am Handy SwipeRow mit „Löschen“/„Profil“ aus App.tsx).
export function SchuelerListe({ kinder, klasseId, klassenName, onOeffnen, huelle }: {
  kinder: Schueler[];
  klasseId: number | null;
  klassenName: string | null;
  onOeffnen: (s: Schueler) => void;
  huelle?: (s: Schueler, zeile: React.ReactNode) => React.ReactNode;
}) {
  const [suche, setSuche] = useState('');
  const { daten } = useAufmerksamkeit(klasseId);
  const proKind = new Map((daten?.schueler ?? []).map(k => [k.schueler_id, k]));
  const treffer = kinder.filter(s => s.name.toLowerCase().includes(suche.trim().toLowerCase()));
  const aufmerksam = treffer.map(s => ({ s, g: gruende(proKind.get(s.id)) })).filter(x => x.g.length > 0);

  const zeile = (s: Schueler, inhalt: React.ReactNode) => {
    const knopf = (
      <button type="button" className="ld-kl-zeile" onClick={() => onOeffnen(s)}>
        <span className="ld-kl-avatar" aria-hidden="true">{initialen(undefined, undefined, s.name)}</span>
        <span className="ld-kl-zeile__text">
          <span className="ld-kl-zeile__name" style={{ display: 'block' }}>{s.name}</span>
          {inhalt}
        </span>
        <MIcon name="chevron_right" size={20} className="ld-kl-pfeil" />
      </button>
    );
    return <div key={s.id}>{huelle ? huelle(s, knopf) : knopf}</div>;
  };

  return (
    <div className="ld-page-enter">
      <div className="ld-kl-suche">
        <MIcon name="search" size={20} />
        <input value={suche} onChange={e => setSuche(e.target.value)} placeholder={klassenName ? `Kind in ${klassenName} suchen` : 'Kind suchen'} aria-label="Kind suchen" />
      </div>

      {aufmerksam.length > 0 && (
        <>
          <h2 className="ld-kl-abschnitt">Braucht Aufmerksamkeit <span className="ld-kl-abschnitt__zahl">{aufmerksam.length}</span></h2>
          <div className="ld-kl-karte">
            {aufmerksam.map(({ s, g }) => zeile(s, (
              <span className="ld-kl-chips">
                <span className={`ld-kl-chip ld-kl-chip--${g[0].ton}`}><MIcon name={g[0].icon} size={14} />{g[0].text}</span>
                {g.length > 1 && <span className="ld-kl-mehr-hinweis">und {g.length - 1} {g.length === 2 ? 'weiterer Hinweis' : 'weitere Hinweise'}</span>}
              </span>
            )))}
          </div>
        </>
      )}

      <h2 className="ld-kl-abschnitt">Alle Kinder <span className="ld-kl-abschnitt__zahl">{treffer.length}</span></h2>
      <div className="ld-kl-karte">
        {treffer.map(s => zeile(s, null))}
        {treffer.length === 0 && <div className="ld-kl-leer">{suche ? `Kein Kind mit „${suche}“ gefunden.` : 'In dieser Klasse sind noch keine Kinder eingetragen.'}</div>}
      </div>
    </div>
  );
}
